var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"share"},[_vm._v(" 点击右上角 "),_c('img',{staticClass:"margin-lr-4",attrs:{"src":_vm.$oss(31),"width":"32","height":"12"}}),_vm._v(" 发送给好友 "),_c('div',{staticClass:"arrow"})]),_c('div',{staticClass:"i-kown",on:{"click":_vm.onClose}},[_vm._v("我知道了")])])
}
var staticRenderFns = []

export { render, staticRenderFns }